import { useEffect } from "react";
import { motion } from "framer-motion";
import DarkMode from "./DarkMode";

const Hero = () => {
  useEffect(() => {
    const handleScroll = () => {
      const svg = document.getElementById("scrollSvg");
      if (svg) {
        if (window.scrollY > 0) {
          svg.classList.add("opacity-0");
        } else {
          svg.classList.remove("opacity-0");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.div
      className="max-w-2xl mx-auto"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.65, delay: 1.1, ease: "easeOut" }}
    >
      <section className="relative min-h-screen bg-cover bg-center flex flex-col items-center justify-center">
        <h1 className="text-center text-4xl md:text-6xl font-bold text-white drop-shadow-xl font-['minecraft']">
          Welcome to{" "}
          <div className="decoration-cyan-400 underline decoration-4 duration-700 dark:decoration-sky-600 hover:decoration-gray-700 ease-in-out">
            Nova Creations
          </div>
        </h1>
        <p className="text-center font-minecraft max-w-3xl leading-6 text-lg md:text-xl mt-4 md:font-bold  tracking-tight text-slate-300 drop-shadow-xl whitespace-normal">
          At NovaCreations, we specialize in creating everything from cozy
          houses to expansive projects and custom maps. With nearly a decade of
          experience, our team is dedicated to delivering top-tier quality.
          Every project starts with a conversation - ensuring your vision is
          brought to life with personalized care and precision!
        </p>
        <svg
          id="scrollSvg"
          className="animate-bounce scale-125 w-12 h-12 absolute bottom-8 transition-opacity duration-500 drop-shadow-2xl"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3Z"
            fill="white"
          />
        </svg>
      </section>
    </motion.div>
  );
};

export default Hero;
